import o from'./../../ext-esm/style-inject/dist/style-inject.es.js';var t={root:"FileIcon_root__9JCcW"};o(".FileIcon_root__9JCcW.MuiSvgIcon-root{height:auto;width:auto}");export{t as default};
